import { request } from "../../Services/Api"

export const sendHowDidYouFindUsData = (data) => {
  return request.api.post("/user/attribution-prompt/answer/", data)
}

export const markAttributionPromptAsShown = () => {
  return request.api.patch("/user/attribution-prompt/mark_shown/", {})
}
